import React from 'react';
import PublicRoute from './PublicRoute';

let PublicRouteContainer = ({ isAuthenticated, ...rest }) => {
    return <PublicRoute isAuthenticated={isAuthenticated} {...rest} />
};

export default PublicRouteContainer;
